import React, { useEffect, useRef } from "react";
import CardHeader from "./CardHeader";
import CardBody from "./CardBody";
import CardFooter from "./CardFooter";
import {useMedia} from "react-use";

const Card = (props) => {

    return (
        <div className={`${props.active ? props.active: ''} card`}>
            <CardHeader background={props.background} color={props.color} plan={props.plan ? props.plan: ''}  title={props.title}/>
            <CardBody plan={props.plan} monthlyPrice={props.monthlyPrice} />
            <CardFooter
                content={
                    <div className="px-4 py-3 d-flex justify-content-center flex-column">
                        <h3 className="font-medium-x-large m-0 medium-bold">Ideal For:</h3>
                        <p className="m-0 font-small">{props.title ? props.title.desc:''}</p>
                    </div>
                }
                isPlan={true}
                active={ props.active ? props.active: "" }
            />
        </div>
    );
}

export default Card;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/card/Card.js